import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';

export const AUDIT_PAGE_SIZE = 50;

// The server authorizes every page; browser permissions only control presentation.
export async function listAuditEvents(filters = {}) {
  const response = await httpsCallable(functions, 'erpAuditAction', { timeout: 60000 })({
    action: 'list',
    module: filters.module || '',
    actorUid: filters.actorUid || '',
    eventAction: filters.eventAction || '',
    from: filters.from || '',
    to: filters.to || '',
    search: filters.search || '',
    outcome: filters.outcome || '',
    actorType: filters.actorType || '',
    entityPath: filters.entityPath || '',
    cursor: filters.cursor || null,
    limit: AUDIT_PAGE_SIZE,
  });
  return response.data;
}

export function auditError(error) {
  const code = String(error?.code || '').replace('functions/', '');
  if (code === 'permission-denied') return 'Audit Trail access is not enabled for your account. Ask an authorized administrator to grant it in Manage Team.';
  if (code === 'unauthenticated') return 'Your session has expired. Sign in again to view the audit trail.';
  if (['unavailable', 'deadline-exceeded', 'network-request-failed'].includes(code)) return 'The activity could not be loaded. Check your connection and try again.';
  return error?.message?.replace(/^Firebase:\s*/, '') || 'The activity could not be loaded. Please try again.';
}

export async function recordAuditActivity(event, module, eventId = window.crypto?.randomUUID?.()) {
  if (!eventId || !auth.currentUser) return;
  return (await httpsCallable(functions, 'erpAuditAction', { timeout: 10000 })({ action: 'activity', event, module, eventId })).data;
}

export const auditModuleForPath = pathname => ({
  '/':'operations','/floor-plan-ops':'operations','/my-tasks':'tasks','/attendance':'attendance',
  '/students':'students','/user-addition':'students','/faculty-timing':'faculty','/schedule':'schedule','/schedule-builder':'schedule',
  '/exams':'exams','/feedback-builder':'feedback','/reports':'reports','/issues':'tickets','/allocate-tickets':'tickets',
  '/ir-manager':'ir','/result-posters':'results','/results-service':'results','/sales-service':'sales','/sales-form-builder':'sales','/marketing-travel':'travel',
  '/finance':'finance','/finance-reimbursements':'finance','/finance-budgets':'finance','/finance-config':'finance','/director-settings':'finance',
  '/hr-dashboard':'hr','/my-portal':'employee','/prp-manager':'prp','/users':'users','/settings/tasks':'settings','/audit-trail':'settings'
}[pathname]);
export function recordExportActivity() {
  const module = auditModuleForPath(window.location.pathname);
  if (module) recordAuditActivity('export', module).catch(() => {});
}

// Quote every cell and neutralize spreadsheet formulas in user-provided names.
export function auditEventsCSV(events) {
  const cell = value => { const s = String(value ?? ''); return '"' + (/^(?:\s*[=+@-]|[\t\r])/.test(s) ? "'" + s : s).replace(/"/g, '""') + '"'; };
  const rows = [['Time (UTC)','User','Role','User ID','Module','Action','Outcome','Record','Changed fields','Identity verification','Source','Event ID'],
    ...events.map(e => [e.occurredAt ? new Date(e.occurredAt).toISOString() : '', e.actor?.name, e.actor?.role, e.actor?.uid, e.module, e.action, e.outcome,
      `${e.entity?.collection || ''}/${e.entity?.id || ''}`, (e.changedFields || []).join('; '), e.identitySource, e.source, e.id])];
  return '\uFEFF' + rows.map(row => row.map(cell).join(',')).join('\r\n');
}
